/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreContinueRedirectWithPiResponse interface.
 */
export function instanceOfFxIdWebFeaturesStoreContinueRedirectWithPiResponse(value) {
    if (!('RedirectUrl' in value) || value['RedirectUrl'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreContinueRedirectWithPiResponseFromJSON(json) {
    return FxIdWebFeaturesStoreContinueRedirectWithPiResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreContinueRedirectWithPiResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'RedirectUrl': json['RedirectUrl'],
    };
}
export function FxIdWebFeaturesStoreContinueRedirectWithPiResponseToJSON(json) {
    return FxIdWebFeaturesStoreContinueRedirectWithPiResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreContinueRedirectWithPiResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'RedirectUrl': value['RedirectUrl'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreContinueRedirectWithPiResponse.js.map